import { useStandardRecipeV2 } from '@ctcells/api'
import { dataSourceFor } from '@ctcells/core'
import { errorMessage } from '@ctcells/i18n'

import type { ResourceTabId } from '../resources/resourceTabs.ts'
import { useScreenAccess } from '../screenAccess.ts'

import { TemplatesScreen } from './TemplatesScreen.tsx'

/**
 * 템플릿 목록 컨테이너 — 🔴 «레시피» 템플릿(`GET /recipes/standard`) 하나만 받는다(eric 2026-10-26 「응.. 다 빼줘」 · 데크 · 작업 ·
 * 랩웨어 · 시약 템플릿 화면은 걷었다). 데이터 소스는 `recipes` 도메인을 따른다. 목(데모)에서는 문서가 없어 표가 빈다 — 목 문서를 짓지 않는다.
 */
export interface TemplatesContainerProps {
  resourceTab?: ResourceTabId | undefined
  selectedId?: string | undefined
}

export function TemplatesContainer(props: TemplatesContainerProps) {
  return dataSourceFor('recipes') === 'demo' ? (
    <TemplatesDemo {...props} />
  ) : (
    <TemplatesLive {...props} />
  )
}

function TemplatesDemo({ resourceTab, selectedId }: TemplatesContainerProps) {
  const access = useScreenAccess()
  return (
    <TemplatesScreen
      access={access}
      selectedId={selectedId}
      {...(resourceTab === undefined ? {} : { resourceTab })}
    />
  )
}

function TemplatesLive({ resourceTab, selectedId }: TemplatesContainerProps) {
  const access = useScreenAccess()
  const standard = useStandardRecipeV2({})
  return (
    <TemplatesScreen
      {...(resourceTab === undefined ? {} : { resourceTab })}
      access={access}
      recipe={{
        doc: standard.data,
        loading: standard.isPending,
        ...(standard.error === null ? {} : { error: errorMessage(standard.error) }),
      }}
      selectedId={selectedId}
    />
  )
}
